module.exports = __webpack_public_path__ + "img/scv_be_attacked.929d4953.jpg";